import { Injectable } from '@angular/core';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';

@Injectable({
  providedIn: 'root',
})
export class CompetenciesSummaryService {
  constructor(private apiService: APICoreService) {}

  getCurrentCompetencies() {
    return this.apiService.getRequest(
      'growelab/competencies/overview?fromLastLog=true'
    );
  }
}
